import "./RatesAndSubscription.css";

import React, { useEffect, useState } from "react";
import {
  deletePurchasedSubscription,
  purchaseSubscription,
} from "Config/API/action";
import {
  getAllSubscribers,
  getAllSubscriptions,
  getClientCreditBalance,
  getRespectiveRates,
} from "Config/API/get";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";

import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutlined";
import DeleteIcon from "@mui/icons-material/Delete";
import Headers from "Components/Header/Headers";
import { IconButton } from "@mui/material";
import Navigation from "Components/SideNavBar/Navigation";
import PurchaseSubscription from "Components/Popup/PurchaseSubscription/PurchaseSubscription";
import QuestionMarkIcon from "@mui/icons-material/QuestionMark";
import RenderConfirm from "Components/Popup/Confirm/Container/RenderConfirm";
import RenderInformationPopup from "Components/Popup/InformationPopup/PureComponents/InformationPopup";
import StripeOnboardingRequiredPopup from "Components/Popup/StripeOnboardingRequiredPopup/StripeOnboardingRequiredPopup";
import VideoCallingRates from "Components/Popup/VideoCallingRates/VideoCallingRates";
import blank from "Media/blank-profile-picture.png";
import editRates from "Media/icons/editRates.png";
import logo from "Media/Amnius_connect_noText.png";
import mySubscribers from "Media/icons/mySubscribers.png";
import mySubscribersLogo from "Media/icons/mySubscribersLogo.png";
import mySubscriptions from "Media/icons/mySubscriptions.png";
import portfolioFiles from "Media/icons/portfolioFiles.png";
import { purchaseSubscriptionMessages } from "Constants/Values";
import rateSetting from "Media/icons/rateSetting.png";
import { requiresStripeOnboarding } from "Helper/stripeConnectGuard";
import { fetchStripeConnectedAccountId } from "Helper/stripeConnectedAccount";
import { renderOrganizationInfo } from "Redux/action/render.action";
import serviceTicketIcon from "Media/Group 353@2x.png";
import { toast } from "react-toastify";
import useIsAmniusOrganization from "Hooks/useIsAmniusOrganization";
import videoChatRate from "Media/icons/videoChatRate.png";
import WalletTopUpModal from "Components/Popup/WalletTopUpModal/WalletTopUpModal";
import {
  getStripeCreditBalanceAction,
  getUsableCreditBalanceAction,
} from "Redux/action/get.action";

const SERVICE_TICKET = "service_ticket";

const subscriptionsHeader = {
  service_ticket: "SERVICE TICKETING MANAGEMENT",
  video_chat: "VIDEO CHAT RATE",
  portfolio: "PORTFOLIO RATE",
};
const subscriptionsPopUpHeader = {
  service_ticket: "Service Ticketing",
  video_chat: "Video Chat",
  portfolio: "Portfolio",
};
const loadingArray = ["", ""];

const TABS = [
  {
    key: "rateSetting",
    label: "Rate Setting",
    icon: rateSetting,
    iconStyle: { width: "50px", height: "50px" },
  },
  {
    key: "mySubscriptions",
    label: "My Subscriptions",
    icon: mySubscriptions,
    iconStyle: { width: "50px", height: "50px" },
  },
  {
    key: "mySubscribers",
    label: "My Subscribers",
    icon: mySubscribers,
    iconStyle: { width: "43px", height: "43px", marginBottom: "7px" },
  },
];

const ROW_STYLE = { display: "flex", alignItems: "center" };
const COLUMN_STYLE = { display: "flex", flexDirection: "column" };
const TILE_STYLE = { justifyContent: "space-between", position: "relative" };
const SKELETON_TILE_STYLE = {
  justifyContent: "space-between",
  borderColor: "#ececec",
};
const SECTION_LOGO_STYLE = { width: "30px", height: "30px", borderRadius: 50 };
const EMPTY_MESSAGE_STYLE = {
  color: "#4671a4",
  marginTop: "10px",
  fontSize: "20px",
  fontWeight: "bolder",
};

const EmptyMessage = ({ children }) => (
  <span style={EMPTY_MESSAGE_STYLE}>{children}</span>
);

const showFailureToast = () => toast("Failed! Try again later", { type: "error" });

const RatesAndSubscription = () => {
  const { state } = useLocation();
  const isOrgAmnius = useIsAmniusOrganization();
  const navigate = useNavigate();
  const token = localStorage.getItem("token");
  const loggedInUserDetails = useSelector(
    (state) => state.authenticationReducer
  );
  const canTopUpWallet = loggedInUserDetails?.add_credit_rights === "manager";
  const isCreditAccountManager =
    loggedInUserDetails?.credit_account_manager === "manager";
  const canManageStripe = isCreditAccountManager;
  const onboardingStatus = useSelector(
    (state) => state.getStripeOnboardingStatusReducer
  );
  const stripeAccountStatus = useSelector(
    (state) => state.getStripeAccountStatusReducer
  );
  const stripeDashboardUrl = useSelector(
    (state) => state.getUsableCrediturlReducer
  );
  const dispatch = useDispatch();

  const [selectedTab, setSelectedTab] = useState(
    state?.tab || "rateSetting"
  );
  const [ratesData, setRatesData] = useState([]);
  const [selectedRatesData, setSelectedRatesData] = useState([]);
  const [serviceTicketingData, setServiceTicketingData] = useState([]);
  const [siteSubscriptions, setSiteSubscriptions] = useState([]);
  const [allSubscriptions, setAllSubscriptions] = useState([]);
  const [allSubscribers, setAllSubscribers] = useState([]);
  const [rateLoading, setRateLoading] = useState(false);
  const [subscriptionsLoading, setSubscriptionsLoading] = useState(false);
  const [subscribersLoading, setSubscribersLoading] = useState(false);
  const [showConfirmPopup, setShowConfirmPopup] = useState(false);
  const [showEditRatesPopup, setShowEditRatesPopup] = useState(false);
  const [showEditServiceTicketRatesPopup, setShowEditServiceTicketRatesPopup] =
    useState(false);
  const [purchaseLoading, setPurchaseLoading] = useState(false);
  const [showPurchaseSubscription, setShowPurchaseSubscription] =
    useState(false);
  const [showStripeOnboardingPopup, setShowStripeOnboardingPopup] =
    useState(false);
  const [showWalletTopup, setShowWalletTopup] = useState(false);
  const [selectedSubscription, setSelectedSubscription] = useState([]);
  const [infoPopup, setInfoPopup] = useState(false);
  const [tabsText, setTabsText] = useState("");
  const generalInfo = useSelector((state) => state.renderGeneralInfo);
  const [stripeAccountId, setStripeAccountId] = useState(null);
  const hasStripeConnectedId = Boolean(stripeAccountId);
  const hasStripeDashboardUrl = Boolean(
    stripeDashboardUrl && String(stripeDashboardUrl).trim()
  );
  const canUseWalletActions = hasStripeConnectedId && hasStripeDashboardUrl;
  const availableBalance = Number(
    useSelector((state) => state.getStripeCreditBalanceReducer) || 0
  );

  useEffect(() => {
    let cancelled = false;
    fetchStripeConnectedAccountId(token, loggedInUserDetails, generalInfo).then(
      (accountId) => {
        if (!cancelled) setStripeAccountId(accountId);
      }
    );
    return () => {
      cancelled = true;
    };
  }, [token, loggedInUserDetails, generalInfo]);

  useEffect(() => {
    getAllSubscriptionsRates();
    getAllAvailableSubscriptions();
    getAllSubscribersData();
    // eslint-disable-next-line
  }, []);

  const getAllSubscriptionsRates = () => {
    setRateLoading(true);
    const response = getRespectiveRates(token);
    response.then((res) => {
      setRateLoading(false);
      if (res.data.status) {
        setSelectedRatesData([]);
        setRatesData(res.data.data);
      } else showFailureToast();
    });
  };

  const getAllAvailableSubscriptions = () => {
    setSubscriptionsLoading(true);
    const response = getAllSubscriptions(token);
    response.then((res) => {
      setSubscriptionsLoading(false);
      if (res.data.status) {
        const subscriptions = res.data.data;
        const serviceTickets = subscriptions?.filter(
          (item) => item?.rate_type === SERVICE_TICKET
        );
        setSiteSubscriptions(serviceTickets);
        setAllSubscriptions(
          subscriptions?.filter((item) => item?.rate_type !== SERVICE_TICKET)
        );
        setServiceTicketingData(serviceTickets);
      } else showFailureToast();
    });
  };

  const getAllSubscribersData = () => {
    setSubscribersLoading(true);
    const response = getAllSubscribers(token);
    response.then((res) => {
      setSubscribersLoading(false);
      if (res.data.status) {
        setAllSubscribers(res.data.data);
      } else showFailureToast();
    });
  };

  const handleDeleteSubscription = (subscriptionId) => {
    setRateLoading(true);
    setSubscriptionsLoading(true);
    const response = deletePurchasedSubscription(token, subscriptionId);
    response.then((res) => {
      if (res.status) {
        setSiteSubscriptions([]);
        setAllSubscriptions([]);
        setSelectedSubscription([]);
        getAllSubscriptionsRates();
        getAllAvailableSubscriptions();
        toast(res.message, { type: "success" });
      } else {
        setRateLoading(false);
        setSubscriptionsLoading(false);
        showFailureToast();
      }
    });
  };

  const subscribeService = () => {
    const response = purchaseSubscription(
      token,
      selectedSubscription?.subscription_type,
      selectedSubscription?.rate,
      selectedSubscription?.subscription_type !== SERVICE_TICKET
        ? selectedSubscription?.subscriptionFrom
        : ""
    );
    response.then((res) => {
      setPurchaseLoading(false);
      if (res.status) {
        if (
          purchaseSubscriptionMessages?.includes(res?.message?.toLowerCase())
        ) {
          toast(res.message, { type: "info" });
        } else {
          setShowPurchaseSubscription(false);
          getAllAvailableSubscriptions();
          toast(res.message, { type: "success" });
        }
      } else showFailureToast();
    });
  };

  const refreshCreditBalance = async () => {
    const accountId =
      stripeAccountId ||
      (await fetchStripeConnectedAccountId(
        token,
        loggedInUserDetails,
        generalInfo
      ));
    if (!accountId) return;

    const response = await getClientCreditBalance(token, accountId);
    if (response?.data?.status) {
      const creditData = response?.data?.data?.[0] || {};
      dispatch(getStripeCreditBalanceAction(creditData?.amount));
      dispatch(getUsableCreditBalanceAction(creditData?.usableAmount));
    }
  };

  const showInfo = (text) => {
    setInfoPopup(true);
    setTabsText(text);
  };

  const renderInfoIcon = (text) => (
    <QuestionMarkIcon
      className="moneyCreditManagement-info"
      onClick={() => showInfo(text)}
    />
  );

  // Returns true (and prompts the user) when Stripe onboarding must be completed first.
  const blockUntilStripeOnboarded = (message) => {
    if (!requiresStripeOnboarding(onboardingStatus, stripeAccountStatus)) {
      return false;
    }
    toast(message, { type: "info" });
    setShowStripeOnboardingPopup(true);
    return true;
  };

  const canManageSubscription = (item) =>
    (item?.rate_type === SERVICE_TICKET &&
      loggedInUserDetails?.ticket_subscription === "manager") ||
    (item?.rate_type === "portfolio" &&
      loggedInUserDetails?.portfolio_subscription === "manager");

  const renderSubscriptions = (arr) =>
    arr?.length > 0 ? (
      <div className="rates-and-subscription-lower-tile-content-container">
        {arr.map((item) => (
          <div
            key={item?.id}
            className="rates-and-subscription-lower-tile"
            style={TILE_STYLE}
          >
            <div style={ROW_STYLE}>
              <img
                src={
                  item?.rate_type === SERVICE_TICKET
                    ? serviceTicketIcon
                    : portfolioFiles
                }
                alt="videoChatRate"
                style={{ width: "76px", height: "76px" }}
              />
              <div style={COLUMN_STYLE}>
                <label>{subscriptionsHeader[item?.subscription_type]}</label>
                {item?.subscription_type !== SERVICE_TICKET && (
                  <label style={{ fontSize: "13px" }}>
                    Org Name : {item?.organization_name}
                  </label>
                )}
                <span>Monthly Fee: {item?.rate} Credits</span>
                {item?.subscriptionStatus?.toString() === "true" &&
                  !isOrgAmnius && (
                    <label style={{ fontSize: "13px", color: "#C50000" }}>
                      {item?.isSubscribed?.toString() === "true"
                        ? "Renews on: "
                        : "Ends on: "}
                      {item?.subscriptionEndDate}
                    </label>
                  )}
              </div>
            </div>

            {!isOrgAmnius &&
              canManageSubscription(item) &&
              (item?.isSubscribed?.toString() === "true" ? (
                <IconButton
                  onClick={() => {
                    setSelectedSubscription(item);
                    setShowConfirmPopup(true);
                  }}
                >
                  <DeleteIcon style={{ color: "#4671A4" }} fontSize="medium" />
                </IconButton>
              ) : (
                <IconButton
                  onClick={() => {
                    if (
                      blockUntilStripeOnboarded(
                        "Complete Stripe onboarding before purchasing subscriptions."
                      )
                    ) {
                      return;
                    }
                    setSelectedSubscription(item);
                    setShowPurchaseSubscription(true);
                  }}
                >
                  <AddCircleOutlineIcon
                    style={{ color: "#4671A4" }}
                    fontSize="medium"
                  />
                </IconButton>
              ))}
            {renderInfoIcon(`${subscriptionsHeader[item?.rate_type]}`)}
          </div>
        ))}
      </div>
    ) : (
      <EmptyMessage>No Subscriptions Found</EmptyMessage>
    );

  return (
    <>
      <div className="rates-and-subscription-main">
        <div className="rates-and-subscription-header">
          <Headers />
        </div>

        <div className="rates-and-subscription-navigation">
          <Navigation />
        </div>

        <div className="rates-and-subscription-wrapper">
          <div className="rates-and-subscription-heading">
            Rates & Subscription Management
            {(canTopUpWallet || canManageStripe) && (
              <div style={{ marginTop: "8px", display: "flex", gap: "8px" }}>
                {canTopUpWallet && (
                  <button
                    className="rates-and-subscription-lower-tile-button"
                    onClick={() => {
                      if (
                        blockUntilStripeOnboarded(
                          "Complete Stripe onboarding before topping up your wallet."
                        )
                      ) {
                        return;
                      }
                      if (!canUseWalletActions) return;
                      setShowWalletTopup(true);
                    }}
                  >
                    Top Up Wallet
                  </button>
                )}
                {canManageStripe && stripeDashboardUrl && (
                  <button
                    className="rates-and-subscription-lower-tile-button"
                    style={{ background: "#eceff4", color: "#35557f" }}
                    onClick={() => window.open(stripeDashboardUrl, "_blank")}
                  >
                    Manage Stripe Account
                  </button>
                )}
              </div>
            )}
          </div>
          <div className="rates-and-subscription-content">
            {TABS.map(({ key, label, icon, iconStyle }) => (
              <div key={key} className="rates-and-subscription-infoText">
                <div
                  className={`rates-and-subscription-tile${
                    selectedTab === key ? " active" : ""
                  }`}
                  onClick={() => setSelectedTab(key)}
                >
                  <img src={icon} alt={key} style={iconStyle} />
                  <span>{label}</span>
                </div>
                {selectedTab === key && renderInfoIcon(label)}
              </div>
            ))}
          </div>
          <div className="rates-and-subscription-lower-tile-container">
            {selectedTab === "rateSetting" &&
              (!rateLoading ? (
                ratesData?.length > 0 ? (
                  <div className="rates-and-subscription-lower-tile-content-container">
                    {ratesData.map((item) => {
                      const isVideoChat = item?.rate_type === "video_chat";
                      return (
                        <div
                          key={item?.rate_type}
                          className="rates-and-subscription-lower-tile"
                          style={TILE_STYLE}
                        >
                          <div style={ROW_STYLE}>
                            <img
                              src={isVideoChat ? videoChatRate : portfolioFiles}
                              alt="videoChatRate"
                              style={{ width: "76px", height: "76px" }}
                            />
                            <div style={COLUMN_STYLE}>
                              <label>
                                {subscriptionsHeader[item?.rate_type]}
                              </label>
                              {item?.rate ? (
                                <span>
                                  ${item.rate} Credits Per{" "}
                                  {isVideoChat ? "Minute" : "Month"}
                                </span>
                              ) : (
                                <span style={{ color: "#C50000" }}>
                                  Please set rate per{" "}
                                  {isVideoChat ? "minute" : "month"}
                                </span>
                              )}
                            </div>
                          </div>
                          {isCreditAccountManager && (
                            <img
                              src={editRates}
                              alt="editRates"
                              style={{ width: "21px", height: "22px" }}
                              onClick={() => {
                                if (
                                  (isVideoChat ||
                                    item?.rate_type === "portfolio") &&
                                  blockUntilStripeOnboarded(
                                    "Complete Stripe onboarding before setting video chat or portfolio rates."
                                  )
                                ) {
                                  return;
                                }
                                setSelectedRatesData([item]);
                                setShowEditRatesPopup(true);
                              }}
                            />
                          )}
                          {renderInfoIcon(
                            `${subscriptionsHeader[item?.rate_type]}`
                          )}
                        </div>
                      );
                    })}
                  </div>
                ) : (
                  <EmptyMessage>No Rates Found</EmptyMessage>
                )
              ) : (
                <div className="rates-and-subscription-lower-tile-content-container">
                  {loadingArray.map((_, index) => (
                    <div
                      key={index}
                      className="rates-and-subscription-lower-tile"
                      style={SKELETON_TILE_STYLE}
                    >
                      <div style={ROW_STYLE}>
                        <div
                          style={{ width: "70px", height: "70px" }}
                          className="animation"
                        />
                        <div
                          style={{
                            ...COLUMN_STYLE,
                            gap: "7px",
                            marginLeft: "22px",
                          }}
                        >
                          <label className="rates-and-subscription-rate-loading-label animation" />
                          <span className="rates-and-subscription-rate-loading-span  animation" />
                        </div>
                      </div>
                      {isCreditAccountManager && (
                        <div
                          style={{ width: "22px", height: "22px" }}
                          className="animation"
                        />
                      )}
                    </div>
                  ))}
                </div>
              ))}
            {selectedTab === "mySubscriptions" && (
              <>
                <div className="rates-and-subscription-lower-tile-header-container">
                  <img src={logo} alt="logo" style={SECTION_LOGO_STYLE} />
                  <span>Site Subscriptions</span>
                </div>
                {!subscriptionsLoading ? (
                  renderSubscriptions(siteSubscriptions)
                ) : (
                  <div className="rates-and-subscription-lower-tile-content-container">
                    <div
                      className="rates-and-subscription-lower-tile"
                      style={{ ...SKELETON_TILE_STYLE, position: "relative" }}
                    >
                      <div style={ROW_STYLE}>
                        <div
                          style={{ width: "70px", height: "57px" }}
                          className="animation"
                        />
                        <div
                          style={{
                            ...COLUMN_STYLE,
                            gap: "7px",
                            marginLeft: "22px",
                          }}
                        >
                          <label className="rates-and-subscription-subscriptions-loading-label  animation" />
                          <span className="rates-and-subscription-subscriptions-loading-span  animation" />
                        </div>
                      </div>
                      <div
                        style={{
                          width: "22px",
                          height: "22px",
                          marginRight: "10px",
                        }}
                        className="animation"
                      />
                    </div>
                  </div>
                )}
                <div className="rates-and-subscription-lower-tile-header-container">
                  <img
                    src={mySubscribersLogo}
                    alt="logo"
                    style={SECTION_LOGO_STYLE}
                  />
                  <span>Locked Content Subscriptions</span>
                </div>
                {!subscriptionsLoading ? (
                  renderSubscriptions(allSubscriptions)
                ) : (
                  <div className="rates-and-subscription-lower-tile-content-container">
                    {loadingArray.map((_, index) => (
                      <div
                        key={index}
                        className="rates-and-subscription-lower-tile"
                        style={SKELETON_TILE_STYLE}
                      >
                        <div style={ROW_STYLE}>
                          <div
                            style={{ width: "70px", height: "70px" }}
                            className="animation"
                          />
                          <div
                            style={{
                              ...COLUMN_STYLE,
                              gap: "5px",
                              marginLeft: "22px",
                            }}
                          >
                            <label className="rates-and-subscription-bottom-subscriptions-loading-top-label animation" />
                            <label className="rates-and-subscription-bottom-subscriptions-loading-mid-label animation" />
                            <span className="rates-and-subscription-bottom-subscriptions-loading-span animation" />
                            <label className="rates-and-subscription-bottom-subscriptions-loading-bottom-label animation" />
                          </div>
                        </div>
                        <div
                          style={{
                            width: "22px",
                            height: "22px",
                            marginRight: "10px",
                          }}
                          className="animation"
                        />
                      </div>
                    ))}
                  </div>
                )}
              </>
            )}
            {selectedTab === "mySubscribers" && (
              <>
                <div className="rates-and-subscription-lower-tile-header-container">
                  <img
                    src={mySubscribersLogo}
                    alt="logo"
                    style={SECTION_LOGO_STYLE}
                  />
                  <span>Locked Content Subscribers</span>
                </div>
                {!subscribersLoading ? (
                  allSubscribers?.length > 0 ? (
                    <div className="rates-and-subscription-lower-tile-content-container">
                      {allSubscribers.map((item) => (
                        <div
                          key={item?.org_id}
                          className="rates-and-subscription-lower-tile"
                          style={TILE_STYLE}
                        >
                          <div style={ROW_STYLE}>
                            <img
                              src={item?.organization?.logo || blank}
                              alt="orgLogo"
                              style={{
                                width: "70px",
                                height: "70px",
                                borderRadius: 50,
                                objectFit: "contain",
                              }}
                              onError={(e) => {
                                e.target.onerror = null; // Prevent infinite loop
                                e.target.src = blank; // Fallback to demo image
                              }}
                            />
                            <div style={COLUMN_STYLE}>
                              <span>{item?.organization?.organization_name}</span>
                            </div>
                          </div>
                          <button
                            className="rates-and-subscription-lower-tile-button"
                            onClick={() => {
                              navigate("/organization", {
                                state: { data: item?.org_id },
                              });
                              dispatch(renderOrganizationInfo({}));
                            }}
                          >
                            Visit Page
                          </button>
                          {renderInfoIcon("Locked Content Subscribers")}
                        </div>
                      ))}
                    </div>
                  ) : (
                    <EmptyMessage>No Subscribers Found</EmptyMessage>
                  )
                ) : (
                  <div className="rates-and-subscription-lower-tile-content-container">
                    {loadingArray.map((_, index) => (
                      <div
                        key={index}
                        className="rates-and-subscription-lower-tile"
                        style={SKELETON_TILE_STYLE}
                      >
                        <div style={ROW_STYLE}>
                          <div
                            style={{
                              width: "70px",
                              height: "70px",
                              borderRadius: 50,
                            }}
                            className="animation"
                          />
                          <span className="rates-and-subscription-subscribers-loading-span animation" />
                        </div>
                        <div className="rates-and-subscription-subscribers-loading-button animation" />
                      </div>
                    ))}
                  </div>
                )}
              </>
            )}
          </div>
        </div>
      </div>
      {showEditRatesPopup && (
        <VideoCallingRates
          hide={setShowEditRatesPopup}
          ratesData={selectedRatesData}
          message={`You are Setting ${
            subscriptionsPopUpHeader[selectedRatesData[0]?.rate_type]
          } Rates`}
          rateType={selectedRatesData[0]?.rate_type}
          getAllSubscriptionsRates={getAllSubscriptionsRates}
        />
      )}
      {showEditServiceTicketRatesPopup && (
        <VideoCallingRates
          hide={setShowEditServiceTicketRatesPopup}
          ratesData={serviceTicketingData}
          message="You are Setting Service Ticket Management Rates"
          rateType="service_ticket"
          getAllSubscriptionsRates={getAllAvailableSubscriptions}
        />
      )}
      {showPurchaseSubscription && (
        <PurchaseSubscription
          header={
            subscriptionsPopUpHeader[selectedSubscription?.subscription_type]
          }
          description={`You plan to subscribe to this Service. It will cost you ${selectedSubscription?.rate} Credits per Month`}
          hide={setShowPurchaseSubscription}
          subscribeService={subscribeService}
          setLoading={setPurchaseLoading}
          loading={purchaseLoading}
          requiredAmount={selectedSubscription?.rate}
          availableBalance={availableBalance}
          refreshCreditBalance={refreshCreditBalance}
        />
      )}
      {showConfirmPopup && (
        <RenderConfirm
          message="delete this Service"
          data={selectedSubscription?.id}
          status={handleDeleteSubscription}
          hide={setShowConfirmPopup}
        />
      )}
      {infoPopup && (
        <RenderInformationPopup message={tabsText} hide={setInfoPopup} />
      )}
      {showStripeOnboardingPopup && (
        <StripeOnboardingRequiredPopup
          hide={setShowStripeOnboardingPopup}
          dashboardUrl={stripeDashboardUrl}
        />
      )}
      {showWalletTopup && canTopUpWallet && (
        <WalletTopUpModal
          hide={setShowWalletTopup}
          token={token}
          dashboardUrl={stripeDashboardUrl}
          onSuccess={async () => {
            await refreshCreditBalance();
            setShowWalletTopup(false);
          }}
        />
      )}
    </>
  );
};

export default RatesAndSubscription;
